import { Stack, Typography, pn, replaceSpacesWithUnderscores } from "@compass/core";
import {
  AprResponseStudentParticipationByEthnicBackground,
  AprResponseStudentParticipationByEthnicBackgroundRow,
  ReportPropertyBase,
} from "generated/openApi";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

import { DevExpressReport, renderReportColumn, renderReportSummary } from "components";
import "moment-timezone";

export const StudentParticipationByEthnicBackground = (props: {
  title: string;
  response: AprResponseStudentParticipationByEthnicBackground;
}) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  const onExporting = () => {
    return {
      header: props.title,
      filename: replaceSpacesWithUnderscores(props.title),
      tenantName: appTenantName,
    };
  };

  return (
    <DevExpressReport
      title={props.title}
      dataSource={props.response.rows}
      exportFormats={["pdf", "excel", "csv"]}
      onExporting={onExporting}
      fullPageSize
      showColumnChooser={false}
    >
      {props.response.properties?.map((property) => {
        let cellRender: ((...params: any) => React.ReactNode) | undefined = undefined;

        if (
          property.propertyNameCamel === pn<AprResponseStudentParticipationByEthnicBackgroundRow>("ethnicBackground")
        ) {
          cellRender = (data) => {
            return (
              <Stack>
                <Typography variant="inherit">{data.value}</Typography>
                <Typography variant="caption">{data.data.suffix}</Typography>
              </Stack>
            );
          };
        }

        return renderReportColumn({
          property: property,
          propertyKey: pn<ReportPropertyBase>("propertyName"),
          cellRender: cellRender,
        });
      })}

      {renderReportSummary({
        properties: props.response.properties,
        propertyKey: pn<ReportPropertyBase>("propertyName"),
        hideLabel: true,
      })}
    </DevExpressReport>
  );
};
